




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { authentication } from '@/api/user/user';
@Component
export default class RealName extends Vue {
  @Prop() private modelShow: boolean;
  @Prop() private data: object;
  @Prop() private msg!: string[];
  private loading: boolean = true;
  private visible: boolean = false;
  @Watch('modelShow')
  private routeShow(newv, oldv) {
    this.visible = newv;

    if (this.data && (this.data as any).real_name) {
      (this.formData as any).name = this.getName((this.data as any).real_name);
      (this.formData as any).number = this.getNum(
              (this.data as any).identity_card
      );
    }

  }
  private formData: object = {
    name: '',
    number: '',
  };
  private ruleValidate: object = {
    name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
    number: [
      { required: true, message: '身份证号码不能为空', trigger: 'blur' },
    ],
  };
  private created() {
    if (this.data && (this.data as any).real_name) {
      (this.formData as any).name = this.getName((this.data as any).real_name);
      (this.formData as any).number = this.getNum(
        (this.data as any).identity_card
      );
    }
  }

  // 姓名隐藏
  private getName(name) {
    let returnName = '';
    for (let i = 0; i < name.length - 1; i++) {
      returnName += '*';
    }
    returnName += name[name.length - 1];
    return returnName;
  }
  // 身份证好隐藏
  private getNum(num) {
    let returnNum = num.substr(0, 4) + '**********' + num.substr(14, 4);
    return returnNum;
  }
  private handleValidate() {
    (this.$refs.formValidate as any).validate(valid => {
      if (valid) {
        this.handleSubmit();
      } else {
        return false;
      }
    });
  }
  private async handleSubmit() {
    const res = await authentication({
      real_name: (this.formData as any).name,
      identity_card: (this.formData as any).number,
    });
    if ((res as any).code === '200') {
      this.$Notice.info({
        title: '实名认证',
        desc: '认证成功!',
      });
      this.$emit('realNameClose', { submit: true });
    } else {
      this.$Notice.error({
        title: '提示',
        desc: (res as any).message || '未知错误！',
      });
    }
  }
  private handleCancel() {
    this.$emit('realNameClose', { submit: false });
  }
}
